const Login = () => import('./views/Login.vue')
const OrderTracking = () => import('./views/OrderTracking.vue')
const CashOnDeliveryPaymentUpdate = () => import('./views/actions/CashOnDeliveryPaymentUpdate.vue')
const OrderCancellation = () => import('./views/actions/OrderCancellation.vue')
const PaymentReinitialization = () => import('./views/actions/PaymentReinitialization.vue')
const RequestOrderCancellation = () => import('./views/actions/RequestOrderCancellation.vue')

const login = {
  path: '/',
  component: Login,
}

const orderTracking = {
  path: '/:id',
  name: 'order',
  component: OrderTracking,
}

const cashOnDeliveryPaymentUpdate = {
  path: '/:id/cash-on-delivery-payment-update',
  name: 'cashOnDeliveryPaymentUpdate',
  meta: { breadcrumb: 'action.order.paymentMethod.update.title' },
  component: CashOnDeliveryPaymentUpdate,
}

const orderPaymentReinitializationV1 = {
  path: '/:id/payments', // older emails from M2 are using this URL
  redirect: { name: 'paymentReinitialization' },
}

const orderPaymentReinitialization = {
  path: '/:id/reinitiate-payment',
  name: 'paymentReinitialization',
  meta: { breadcrumb: 'action.order.payment.reinitiate.title' },
  component: PaymentReinitialization,
}

const orderCancellation = {
  path: '/:id/cancel',
  name: 'orderCancellation',
  meta: { breadcrumb: 'action.order.cancel.title' },
  component: OrderCancellation,
}

const requestOrderCancellation = {
  path: '/:id/request-cancel',
  name: 'requestOrderCancellation',
  meta: { breadcrumb: 'action.order.cancel.title' },
  component: RequestOrderCancellation,
}

export default [
  login,
  cashOnDeliveryPaymentUpdate,
  orderPaymentReinitializationV1,
  orderPaymentReinitialization,
  orderCancellation,
  requestOrderCancellation,
  orderTracking,
]
